<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">Agregar usuario a {{ zona.nombre }}</p>
    </header>
    <div class="modal-card-body">
      <div class="columns">
        <div class="column">
          <div
            v-for="(item, index) in usuarios"
            :key="`sel-usuario-${index}`"
            class="card"
            @click="seleccionarUsuario(item)"
          >
            <div class="card-content">
              <p class="title is-4">
                {{ item.nombre }}
              </p>
              <p class="subtitle is-6">
                {{ item.id }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="cerrarIngresoUsuarioHandle">
        Cerrar
      </button>
    </footer>
    <b-loading
      :is-full-page="false"
      :can-cancel="false"
      :active.sync="estaCargando"
    />
  </div>
</template>

<script>
import { bodegaService } from '@/services'

export default {
  name: 'SeleccionUsuario',
  props: {
    bodega: {
      type: Object,
      required: true
    },
    zona: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      estaCargando: true,
      usuarios: []
    }
  },
  mounted() {
    this.estaCargando = true
    bodegaService
      .getUsuariosByBodega(this.bodega.id)
      .then((response) => (this.usuarios = response.data))
      .catch((error) => this.procesarError(error))
      .then(() => (this.estaCargando = false))
  },
  methods: {
    cerrarIngresoUsuarioHandle() {
      this.$emit('cancelar')
    },
    seleccionarUsuario(usuario) {
      const payload = {
        usuario: usuario,
        zona: this.zona
      }
      this.estaCargando = true
      this.$emit('seleccionar', payload)
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  margin-bottom: 5px;
  &:hover {
    background-color: hsla(204, 86%, 53%, 0.8);
  }
  .card-content {
    padding: 0.5rem 1rem;
    .columns {
      margin-bottom: 0px;
      .column {
        padding: 0.5rem;
      }
    }
  }
}
</style>
